export default __webpack_public_path__ + "static/media/Bike.4ce8839c.svg";